import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=27525a3e&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=27525a3e&prod&lang=less"
import style1 from "./CourseList.vue?vue&type=style&index=1&id=27525a3e&prod&lang=less&scoped=true"
import style2 from "./CourseList.vue?vue&type=style&index=2&id=27525a3e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27525a3e",
  null
  
)

export default component.exports